;(function (angular) {
   'use strict'

   angular.module('azure.alerts', []).factory('alerts', alerts)

   function alerts($rootScope, $timeout) {
      $rootScope.alerts = []
      const queuedAlerts = []

      //================================================================================
      // USAGE
      //================================================================================

      // Exposed Alerts:
      // - core -
      // alerts.success()
      // alerts.info()
      // alerts.warning()
      // alerts.error()
      // - shorthands -
      // alerts.successMessage()
      // alerts.infoMessage()
      // alerts.warningMessage()
      // alerts.errorMessage()
      //
      // Note: the type + "message" alerts are shorthands:
      // Reasoning:
      // Since code like this was so common: alerts.add('danger', error.message);
      // And this is unnecessarily verbose:
      // alerts.error({
      //     message: error.message
      // });
      // We have this:
      // alerts.error(error);
      //
      // Description:
      //    Adds an alert to the $rootScope.alerts array.
      //    Alerts in this array are rendered in index.html
      // Parameters:
      //    options.type: String. Class "Alert--{{type}}" will be added to the alert.
      //    options.message: String. Message to display.
      //    options.autoClose: Bool. Whether to auto-close the alert.
      //    options.closeBtn: Bool. Whether to show the close button.
      //    options.duration: Number. If options.autoClose is true, alert will auto-close after this many milliseconds.
      //    options.fullscreenOverlay: Boolean. If true, a fullscreen overlay will accompany the alert (useful for ensuring user's notice it).
      //    options.queue: Boolean. If true, the alert will be queued. Queued alerts can be added later using addQueued().
      //    options.persist: Boolean. If true, the alert will not be cleared unless clearPersistent=true when calling the clear function.
      //    options.condition: Function. If specified, the alert will not display when it evaluates to falsy.

      //================================================================================
      // INTERNAL
      //================================================================================

      function add(options) {
         if (!options.message) {
            console.error('You must pass a message to alerts.' + options.type)
            return
         }
         if (options.queue) {
            queuedAlerts.push(
               Object.assign({}, options, {
                  queue: false,
               })
            )
            return
         }
         const alert = {
            type: options.type,
            msg: options.message,
            autoClose: options.autoClose,
            closeBtn: options.closeBtn,
            fullscreenOverlay: options.fullscreenOverlay,
            persist: options.persist,
            condition: options.condition,
            close: function () {
               const alertIndex = $rootScope.alerts.indexOf(this)
               if (alertIndex >= 0) {
                  return $rootScope.alerts.splice(alertIndex, 1)
               }
            },
         }
         if (options.autoClose) {
            $timeout(function () {
               alert.close()
            }, options.duration)
         }
         return $rootScope.alerts.push(alert)
      }

      //================================================================================
      // PRIMARY ALERTS
      //================================================================================

      const defaultOptions = {
         autoClose: false,
         duration: 3000,
         closeBtn: true,
         queue: false,
         persist: false,
         condition: function () {
            return true
         },
      }

      // Success - Green
      function success(options) {
         const successDefaults = {
            type: 'success',
            autoClose: true,
            closeBtn: false,
         }
         return add(Object.assign({}, defaultOptions, successDefaults, options))
      }

      // Info - Blue
      function info(options) {
         const infoDefaults = {
            type: 'info',
         }
         return add(Object.assign({}, defaultOptions, infoDefaults, options))
      }

      // Warning - Yellow
      function warning(options) {
         const warningDefaults = {
            type: 'warning',
            persist: true,
         }
         return add(Object.assign({}, defaultOptions, warningDefaults, options))
      }

      // Error - Red
      function error(options) {
         // A falsy message becomes the default message
         if (options && !options.message) {
            delete options.message
         }
         const errorDefaults = {
            type: 'error',
            message: 'There was a problem. Please try again.',
            persist: true,
         }
         return add(Object.assign({}, defaultOptions, errorDefaults, options))
      }

      //================================================================================
      // SHORTHAND ALERTS
      //================================================================================

      function successMessage(message) {
         return success({
            message: message,
         })
      }

      function infoMessage(message) {
         return info({
            message: message,
         })
      }

      function warningMessage(message) {
         return warning({
            message: message,
         })
      }

      function errorMessage(message) {
         return error({
            message: message,
         })
      }

      //================================================================================

      function clear(clearPersistent) {
         $rootScope.alerts.forEach(function (alert) {
            if (clearPersistent || !alert.persist) {
               alert.close()
            }
         })
      }

      function addQueued() {
         const queuedAlertCount = queuedAlerts.length
         for (let i = 0; i < queuedAlertCount; i++) {
            add(queuedAlerts.shift())
         }
      }

      //================================================================================

      return {
         clear: clear,
         addQueued: addQueued,
         // alert Types
         success: success,
         info: info,
         warning: warning,
         error: error,
         // Shorthands (for only passing the message, no customization)
         successMessage: successMessage,
         infoMessage: infoMessage,
         warningMessage: warningMessage,
         errorMessage: errorMessage,
      }
   }
})(angular)
